module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "slider__title"
  }, [_vm._v(_vm._s(_vm.dico.generic_content.insta_bloc_title))]), _c('swiper', {
    ref: "slider",
    staticClass: "tiles__slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('slide-instagram', {
      attrs: {
        "tabindex": "0",
        "aria-label": "instagram slider",
        "slide": slide
      }
    })], 1)
  })), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider__nav"
  }, [_c('div', {
    staticClass: "slider__nav__left"
  }), _c('div', {
    staticClass: "slider__nav__right"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0875d2d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0875d2d4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/SliderComponent.vue
// module id = 810
// module chunks = 0